import { API_URL } from '../../../app-config/constants';
import type { CreateReaction, Reaction } from '../../react/features/Reaction/types';
import { remove as deleteRequest, get as getRequest, post as postRequest } from '../request';

const BASE_URL = `${API_URL}/reaction`;

getAll.operation = 'READ';
getAll.updateOnCreate = ([containerId]: [string], x: Reaction, xs: Reaction[]) => {
    if (x.containerId === containerId) {
        return [...xs, x];
    }
};
export function getAll(containerId: string): Promise<Reaction[]> {
    return getRequest<Reaction[]>(`${BASE_URL}/${containerId}`);
}

create.operation = 'CREATE';
export function create(request: CreateReaction): Promise<Reaction> {
    return postRequest<Reaction>(`${BASE_URL}`, { postData: request });
}

update.operation = 'UPDATE';
export function update(feedback: Reaction): Promise<Reaction> {
    postRequest<Reaction>(`${BASE_URL}/${feedback.id}`, { postData: feedback });
    return Promise.resolve(feedback); // We resolve immediately since there's no need to wait for the request to complete.
}

remove.operation = 'DELETE';
remove.byId = true;
export function remove(id: string): Promise<never> {
    return deleteRequest(`${BASE_URL}/${id}`);
}
